import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
    memberStats: {
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            gap: '32px',
            marginBottom: '8px'
        }
    },
    subHeading: {
        fontSize: '16px',
        fontWeight: '500'
    },
    topStats: {
        marginBottom: '16px',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    },
    rightStats: {
        marginTop: '16px',
        [theme.breakpoints.up('md')]: {
            marginTop: '0px',
            textAlign: 'right'
        }
    },
    ctabutton: {
        cursor: 'pointer',
        fontWeight: '600',
        fontSize: '16px'
    },
    filterBar: {
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            justifyContent: 'space-between'
        }
    },
    grid: {
        boxShadow: theme.palette.mode === 'dark' ? '0 2px 10px 0 rgb(33 150 243 / 10%)' : '0 2px 10px 0 rgb(32 40 45 / 8%)',
        width: '100%'
    },
    tableCell: {
        minWidth: '120px'
    },
    cardTitle: {
        fontSize: '14px',
        color: theme.palette.grey.primary,
        fontWeight: 400
    },
    categoryText: {
        fontWeight: 500,
        color: theme.palette.primary.dark,
        backgroundColor: theme.palette.primary.light,
        borderRadius: theme.spacing(0.5),
        padding: '5px 8px'
    },
    checkboxLabel: {
        fontSize: '14px',
        fontWeight: 500,
        color: theme.palette.grey[900]
    }
}));

export default useStyles;
